import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from "react";
import { Button, Card } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import Typewriter from "typewriter-effect";
import codepen from "../../icons/codepen.svg";
import facebook from "../../icons/facebook.svg";
import github from "../../icons/github.svg";
import linkedIn from "../../icons/linkedin.svg";
import profileImage from "../../images/bg-remove.png";
import './HeaderBottom.css';
const HeaderBottom = () => {
  return (
        <Card 
        style={{backgroundColor:'#EDF0F2'}}
        className="d-flex justify-content-center align-items-center flex-column  border-0 p-5">
          <div className="mb-3">
            <Image className="bg-profile" src={profileImage} width={150} roundedCircle />
          </div>
          <h4
            style={{fontFamily:'"Segoe UI",'}}
            className="font-weight-normal text-muted">
            Hello! I'm
          </h4>
          <p
           className="text-style">          
          <Typewriter
              options={{
                strings: ["Subha Fairuz","Front-End developer", "Web Developer", "JS Developer"],
                autoStart: true,
                loop: true,
                delay: 200,
              }}
            />
            </p>

          <div className="d-flex justify-content-center align-items-center mt-3">
            <a href={"https://github.com/iMsubha"} target="__blank" className="pr-3">
              <Image className="bg-brand p-1"  src={github} height={50} width={50}></Image>
            </a>
            <a href={"https://www.linkedin.com/in/subhafairuz/"} target="__blank" className="pr-3">
              <Image className="bg-brand p-1" src={linkedIn} height={50} width={50}></Image>
            </a>
            <a href={"https://codepen.io/subhafairuz"} target="__blank" className="pr-3">
              <Image className="bg-brand p-1" src={codepen} height={50} width={50}></Image>
            </a>
            <a href={"https://www.facebook.com/subss.subha/"} target="__blank" className="pr-3" >
              <Image className="bg-brand p-1" src={facebook} height={50} width={50}></Image>
            </a>
          </div>

          <a
            className="text-decoration-none mt-3"
            href="https://drive.google.com/uc?export=download&id=1ZA7yVnTlwwV4zV8mavRxSHmAz1kGDKky"
            download
          >
            <Button
              className="font-weight-light text-uppercase btn-main"
              style={{
                backgroundColor: "var(--main-button)",
                borderStyle: "hidden",
              }}
            >
              <small  
              style={{fontFamily:'"Segoe UI",'}}
              className="font-weight-bold"
              >
              <FontAwesomeIcon 
              className="mr-1"
              icon={faDownload} />
              Get Resume</small>{" "}
            </Button>
          </a>
        </Card>
  );
};

export default HeaderBottom;
